import React, { useState } from 'react';

import FormularioModal from '../../../_layout/masterComponents/FormularioModal';

import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import Close from "@material-ui/icons/Close";

import { generarSeguimientosProgramaAnual } from '../../../mutations/SeguimientoSeguros';
import { info, danger } from '../../../_layout/helpers/colores';

const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
    .map((label, i) => ({ value: String(i + 1), label }));

// Genera a mano los seguimientos de las tareas del Programa Anual que inician en el mes elegido.
// Es lo mismo que hace la tarea programada el último día de cada mes; no duplica.
function GenerarProgramaAnual({ token, onClose, onGenerado }) {

    const siguiente = new Date();
    siguiente.setDate(1);
    siguiente.setMonth(siguiente.getMonth() + 1);

    const anioActual = new Date().getFullYear();
    const anios = [anioActual - 1, anioActual, anioActual + 1].map(a => ({ value: String(a), label: String(a) }));

    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [state, setState] = useState({ anio: String(siguiente.getFullYear()), mes: String(siguiente.getMonth() + 1) });
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [loader, setLoader] = useState(false);

    const inputs = [{
        id: "Periodo",
        tipo: "fieldset",
        leyenda: "Se crean los seguimientos de las tareas del Programa Anual que inician en el mes y no están terminadas. Las que ya tienen seguimiento no se repiten.",
        grid: { lg: 12 },
        inputs: [
            {
                disabled: loader,
                id: "anio",
                value: state.anio,
                tipo: "select",
                data: anios,
                title: "Año *",
                grid: { md: 6, lg: 6 },
                onChange: ({ target: { value } }) => setState({ ...state, anio: value })
            },
            {
                disabled: loader,
                id: "mes",
                value: state.mes,
                tipo: "select",
                data: meses,
                title: "Mes *",
                grid: { md: 6, lg: 6 },
                onChange: ({ target: { value } }) => setState({ ...state, mes: value })
            }
        ]
    }];

    async function ftGenerar() {
        setLoader(true);
        try {
            let mensaje = await generarSeguimientosProgramaAnual({ anio: Number(state.anio), mes: Number(state.mes) }, token);
            onGenerado(mensaje);
        } catch ({ message }) {
            setNotificaciones({ mensaje: message, color: danger, open: true });
            setLoader(false);
        }
    }

    const acciones = [{
        loader,
        disabled: loader,
        icono: PlaylistAddCheckIcon,
        color: info,
        descripcion: "Generar",
        onClick: ftGenerar
    }, {
        disabled: loader,
        icono: Close,
        color: danger,
        descripcion: "Cerrar",
        onClick: onClose
    }];

    return (
        <FormularioModal
            open={true}
            title="Generar seguimientos desde Programa Anual"
            onClose={onClose}
            notificaciones={notificaciones}
            closeNotification={() => setNotificaciones({ ...cleanNotificaciones })}
            inputs={inputs}
            acciones={acciones}
        />
    );
}

export default GenerarProgramaAnual;
